import TopFiltersToRegister from './TopFiltersToRegister';
export default TopFiltersToRegister;
